<template>
  <div class="with-margin">
    <section class="tab-content">
      <nav class="level">
        <div class="level-left">
          <div class="level-item">
            <button class="button is-small is-primary" @click="createRecord">
              สร้าง
            </button>
          </div>
        </div>
        <div class="level-right">
          <div class="level-item" v-if="currentUser.isAdmin">
            <b-select
              class="userSelect"
              v-model="selectedUser"
              placeholder="เลือก ผู้ใช้"
              @input="filterByUser"
            >
              <option
                v-for="(option, idx) in users"
                :value="option"
                :key="idx"
                >{{ option.name }}</option
              >
            </b-select>
          </div>
          <div class="level-item">
            <input type="date" v-model="fStartDate" />
            <span>-</span>
            <input type="date" v-model="fEndDate" />
            <button class="button is-small filter-button" @click="filter">
              filter
            </button>
          </div>
        </div>
      </nav>
      <b-table :data="records" @select="viewRecord" :row-class="getRowClass">
        <template slot-scope="props">
          <b-table-column field="status" label="สถานะ">{{
            props.row.isApproved ? "อนุมัติ" : "ไม่อนุมัติ"
          }}</b-table-column>
          <!-- <b-table-column field="company" label="บริษัทประกันภัย">
            <span v-if="props.row.user && props.row.user.company">{{
              props.row.user.company.name
            }}</span>
          </b-table-column>-->
          <b-table-column field="policy" label="เลขกรมธรรม์"
            >{{ props.row.policy.no }} ({{
              props.row.policy.memo
            }})</b-table-column
          >
          <!-- <b-table-column field="policy" label="กรรมธรรม์คงเหลือ">
            <template v-for="p in props.row.user.policies">
              <span :key="p.no" v-if="p.no == props.row.policy.no">
                {{ p.balance }}
              </span>
            </template>
          </b-table-column>-->
          <b-table-column field="policy" label="จำนวนต่อเล่ม">{{
            props.row.policy.balance
          }}</b-table-column>
          <b-table-column field="record" label="จำนวน(0-70, 71-80, 81+)">
            {{
              parseInt(props.row.medium) +
                parseInt(props.row.old) +
                parseInt(props.row.young)
            }}
            ( {{ props.row.young }}, {{ props.row.medium }},
            {{ props.row.old }}
            )
          </b-table-column>
          <b-table-column field="total" label="จำนวนคงเหลือ">
            {{
              props.row.policy.balance -
                (parseInt(props.row.medium) +
                  parseInt(props.row.old) +
                  parseInt(props.row.young))
            }}
          </b-table-column>
          <!-- <b-table-column field="user" label="บันทึกโดย">
            {{ props.row.user.name }}
          </b-table-column>-->
          <b-table-column field="createdAt" label="วันที่บันทึก">{{
            moment(props.row.createdAt.toDate()).format("ll")
          }}</b-table-column>
          <b-table-column field="confirmedAt" label="วันที่ยืนยัน Email">
            {{
              props.row.confirmedAt
                ? moment(props.row.confirmedAt.toDate()).format("ll")
                : ""
            }}
          </b-table-column>
        </template>
      </b-table>
      <b-modal
        :active.sync="isViewActive"
        :width="640"
        scroll="keep"
        @close="deselect"
      >
        <div class="card">
          <div class="card-content">
            เรียน จนท. {{ record.user && record.user.company.name }}
            <br />นำส่งรายชื่อนักท่องเที่ยวเพื่อเอาประกันภัย
            <br />
            {{ record.user && record.user.name }} &nbsp;
            {{ record.policy && record.policy.no }}
            <br />
            <br />
            ทริป
            {{
              moment(record.startAt && record.startAt.toDate()).format("lll")
            }}
            - {{ moment(record.endAt && record.endAt.toDate()).format("lll") }}
            <br />
            <br />
            <b>จำนวน นักท่องเที่ยว</b>
            <br />
            อายุ 0-70 ปี {{ record.young }} คน
            <br />
            อายุ 71-80 ปี {{ record.medium }} คน
            <br />
            อายุ >= 81 ปี {{ record.old }} คน
            <br />
            <br />
            <br />
            หมายเหตุ: {{ record.remark }}
            <br />
            <br />
            บันทึกโดย: {{ record.user && record.user.name }}
            <br />
            <br />ไฟล์แนบ: All Attachment Files
            <br />
            <ul id="example-1">
              <li v-for="(item, idx) in record.attachments" :key="idx">
                <a v-bind:href="item">File [{{ idx }}]</a>
              </li>
            </ul>
          </div>
          <template v-if="currentUser.isAdmin && !record.isApproved">
            <button class="button is-primary is-pulled-right" @click="approve">
              อนุมัติส่งกรมธรรม์
            </button>
          </template>
        </div>
      </b-modal>
      <b-modal
        :active.sync="isModalActive"
        :width="640"
        scroll="keep"
        @close="deselect"
      >
        <div class="card">
          <div class="card-content">
            <b-field label="บริษัทประกันภัย">
              <b-input disabled v-model="user.company.name"></b-input>
            </b-field>

            <b-field label="ผู้ถือกรมธรรม์">
              <b-input disabled v-model="user.name"></b-input>
            </b-field>

            <b-field label="กรมธรรม์">
              <b-select v-model="form.policy" placeholder="เลือก กรมธรรม์">
                <option
                  v-for="(option, idx) in user.policies"
                  :value="option"
                  :key="idx"
                  >{{ option.no }} ---({{ option.balance }})</option
                >
              </b-select>
            </b-field>
            <b-field label="อายุ 0-70">
              <b-input type="number" v-model="form.young" required></b-input>
            </b-field>
            <b-field label="อายุ 71-80">
              <b-input type="number" v-model="form.medium" required></b-input>
            </b-field>
            <b-field label="อายุ 81+">
              <b-input type="number" v-model="form.old" required></b-input>
            </b-field>
            <b-field label="เริ่มทริป">
              <b-datepicker
                v-model="form.startAt"
                placeholder="พิมพ์ หรือ เลือกวันที่"
                icon="calendar-today"
              ></b-datepicker>
              <b-timepicker
                v-model="form.startAt"
                rounded
                placeholder="คลิ๊กเพื่อเลือก"
                icon="clock"
                :hour-format="'24'"
              ></b-timepicker>
            </b-field>
            <b-field label="จบทริป">
              <b-datepicker
                v-model="form.endAt"
                placeholder="คลิ๊กเพื่อเลือก"
                icon="calendar-today"
              ></b-datepicker>
              <b-timepicker
                v-model="form.endAt"
                rounded
                placeholder="คลิ๊กเพื่อเลือก"
                icon="clock"
                :hour-format="'24'"
              ></b-timepicker>
            </b-field>
            <b-field label="หมายเหตุอื่นๆ">
              <b-input v-model="form.remark"></b-input>
            </b-field>
            <section class="uploader is-clearfix">
              <b-field>
                <b-upload v-model="dropFiles" multiple>
                  <a class="button is-primary">
                    <b-icon icon="upload"></b-icon>
                    <span>อัปโหลดรูป</span>
                  </a>
                </b-upload>
              </b-field>

              <div class="tags">
                <span
                  v-for="(file, index) in dropFiles"
                  :key="index"
                  class="tag is-primary"
                >
                  {{ file.name }}
                  <button
                    class="delete is-small"
                    type="button"
                    @click="deleteDropFile(index)"
                  ></button>
                </span>
              </div>
            </section>
            <section class="is-clearfix">
              <button
                class="button is-primary is-pulled-right"
                :disabled="canSubmit()"
                @click="submit"
              >
                ส่งกรมธรรม์
              </button>
            </section>
          </div>
        </div>
      </b-modal>
    </section>

    <b-loading
      :is-full-page="isFullPage"
      :active.sync="isLoading"
      :can-cancel="false"
    ></b-loading>
  </div>
</template>

<script>
import firebase from "firebase";

import { db } from "@/main";
import randomid from "randomid";
import moment from "moment";

function putFiles(files) {
  let ref = firebase.storage().ref();
  let userId = firebase.auth().currentUser.uid;
  return Promise.all(
    files.map(function(file) {
      return db
        .collection("files")
        .add({
          uploaded: false,
          createdAt: new Date(),
          userId: userId
        })
        .then(fileRef => {
          let fileId = fileRef.id;
          return ref
            .child(fileId)
            .put(file)
            .then(snapshot => {
              return fileRef
                .update({ uploaded: true })
                .then(() => snapshot.ref.getDownloadURL());
            });
        });
    })
  );
}

const getInitialRecords = user => {
  if (user.isAdmin) return db.collection("records");
  else return db.collection("records").where("uid", "==", user.uid);
};

export default {
  name: "records",
  data() {
    return {
      isModalActive: false,
      fStartDate: null,
      fEndDate: null,
      isViewActive: false,
      record: {},
      records: [],
      user: { company: {} },
      users: [],
      selectedUser: null,
      dropFiles: [],
      isLoading: false,
      isFullPage: true,
      moment: moment,
      form: {
        young: 0,
        medium: 0,
        old: 0,
        startAt: new Date(),
        endAt: new Date(),
        isApproved: false
      }
    };
  },
  firestore() {
    const user = this.$store.state.currentUser;
    let now = new Date();
    let monthAgo = new Date(now.getTime() - 1000 * 60 * 60 * 24 * 7); // default start at 30 days ago
    return {
      user: db.collection("users").doc(user.uid),
      users: db.collection("users"),
      records: getInitialRecords(user)
        .orderBy("createdAt", "desc")
        .where("createdAt", ">", monthAgo)
    };
  },
  computed: {
    currentUser() {
      return this.$store.state.currentUser;
    }
  },
  methods: {
    canSubmit() {
      const { policy, young, medium, old } = this.form;
      return !policy || young + medium + old < 1;
    },
    filter() {
      if (!this.fStartDate || !this.fEndDate) return;
      const user = this.$store.state.currentUser;
      const selectedUserRef = db.collection("users").doc(this.selectedUser.uid);
      this.$bind(
        "records",
        getInitialRecords(user)
          .where("createdAt", ">", new Date(this.fStartDate))
          .where("createdAt", "<", new Date(this.fEndDate))
          .where("user", "==", selectedUserRef)
      );
    },
    filterByUser() {
      const user = this.$store.state.currentUser;
      const selectedUserRef = db.collection("users").doc(this.selectedUser.uid);
      this.$bind(
        "records",
        getInitialRecords(user)
          .where("user", "==", selectedUserRef)
          .orderBy("createdAt", "desc")
      );
    },
    resetForm() {
      this.form.young = 0;
      this.form.medium = 0;
      this.form.old = 0;
      this.form.startAt = new Date();
      this.form.endAt = new Date();
      this.form.isApproved = false;
    },

    submit() {
      const id = randomid(4);
      // this.form.user = this.user;
      this.form.user = db.collection("users").doc(this.user.uid);
      this.form.uid = this.user.uid;
      this.form.ref = id.toUpperCase();
      this.form.createdAt = new Date();
      let submitData = this.form;

      submitData.yong = parseInt(this.form.yong);
      submitData.medium = parseInt(this.form.medium);
      submitData.old = parseInt(this.form.old);

      this.isLoading = true;
      let files = this.dropFiles;
      return putFiles(files)
        .then(downloadUrls => {
          this.form.attachments = downloadUrls;
          db.collection("records")
            .add(submitData)
            .then(recordRef => {
              console.log(recordRef.id);
              this.isModalActive = false;
              this.dropFiles = [];
              this.isLoading = false;
              this.resetForm();
            });
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    approve() {
      const record = this.record;
      db.collection("records")
        .doc(record.id)
        .update({ isApproved: true, approvedAt: new Date() })
        .then(() => {
          let userRef = db.collection("users").doc(record.uid);
          return userRef.get().then(userSnap => {
            let user = userSnap.data();
            let currentPolicies = user.policies;
            let newPolicies = currentPolicies.map(p => {
              // console.log(record.policy.no, p.no);
              return {
                no: p.no,
                memo: p.memo,
                balance:
                  record.policy.no == p.no
                    ? parseInt(p.balance) -
                      (parseInt(record.young) +
                        parseInt(record.medium) +
                        parseInt(record.old))
                    : p.balance
              };
            });
            return userRef.update({
              policies: newPolicies
            });
          });
        });
      this.deselect();
    },

    deselect() {
      this.isModalActive = false;
      this.isViewActive = false;
    },

    createRecord() {
      this.isModalActive = true;
    },

    viewRecord(row) {
      this.record = { ...row, id: row.id };
      this.isViewActive = true;
    },
    getRowClass(row) {
      return !row.isApproved ? "row-approve-bg" : "";
    }
  }
};
</script>

<style scoped>
.with-margin {
  margin: 10px;
}
.filter-button {
  margin-left: 10px;
}
.uploader {
  margin-bottom: 15px;
}

@media only screen and (max-width: 600px) {
  input {
    width: 80%;
  }
  .userSelect {
    width: 100%;
  }
  button {
    width: 40%;
  }
}
</style>
